<template>
  <b-container fluid>
    <b-row>
      <b-col class="top_bar" />
    </b-row>
    <b-row
      ><b-col><div class="page_title">Course Administration</div></b-col></b-row
    >
    <b-row class="mb-3">
      <b-col class="col-auto">
        <div class="search_input" :style="{ 'min-width': '300px' }">
          <span class="fa fa-search search_input-icon" />
          <input
            v-model="searchString"
            type="text"
            class="form-control tsny_input search_input-input"
            :placeholder="'Search Courses'"
          />
        </div>
      </b-col>
      <b-col>
        <b-button class="tsny_button" @click="createCourse"
          >+ Create Course</b-button
        >
      </b-col>
    </b-row>
    <b-row>
      <b-col class="col-auto">
        <b-table
          :style="{ 'min-width': '300px' }"
          class="tsny_text-mid text-center"
          thead-tr-class="tsny_table-head"
          tbody-tr-class="tsny_table-body"
          borderless
          selectable
          :select-mode="'single'"
          striped
          :items="courses"
          :fields="fields"
          :filter="searchString"
          @row-selected="rowSelected"
        />
      </b-col>
      <b-col
        ><edit-course
          class="mb-5"
          v-if="selectedCourse"
          :course="selectedCourse"
      /></b-col>
    </b-row>
    <create-course-modal />
  </b-container>
</template>

<script>
import CourseRestService from "../../services/rest/services/CourseRestService";
import CreateCourseModal from "../../components/CourseAdministration/CreateCourseModal";
import EditCourse from "../../components/CourseAdministration/EditCourse";

export default {
  name: "CourseAdministration",
  components: {
    editCourse: EditCourse,
    createCourseModal: CreateCourseModal
  },
  data: function() {
    return {
      courses: null,
      fields: [{ key: "_id", label: "Course Name", sortable: true }],
      searchString: null,
      selectedCourse: null
    };
  },
  mounted: function() {
    let $comp = this;
    return CourseRestService.getCourses()
      .then(response => {
        $comp.courses = response.data || [];
      })
      .catch(err => {
        console.log(err);
      });
  },
  methods: {
    createCourse: function() {
      this.$bvModal.show("createCourseModal");
    },
    rowSelected: function(items) {
      this.selectedCourse = items[0];
    }
  }
};
</script>

<style scoped></style>
